import { formatOptionsList } from '../../../../../../features/formatters'
import { AD_INVENTORY } from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { RIGHT_INVENTORY_SELECT, TARGETING_OPTION, targetingOptions } from '../fields'

export interface PlacementItem {
  placement_id: number
  [key: string]: any
}

export interface AdUnitItem {
  ad_unit_id: number
  [key: string]: any
}

export type InventoryItem = PlacementItem | AdUnitItem

export const inventoryTypes = {
  placements: 'placements',
  ad_units: 'ad_units'
} as const

export type InventoryType = (typeof inventoryTypes)[keyof typeof inventoryTypes]

export const getGamInventoryType = (inventoryList: InventoryItem[]): InventoryType => {
  const firstInventoryItem = inventoryList?.[0]

  // inventory items have either 'placement_id' or 'ad_unit_id' field
  if (firstInventoryItem && 'placement_id' in firstInventoryItem) {
    return inventoryTypes.placements
  } else {
    // Default to ad_units if placement_id is not present
    return inventoryTypes.ad_units
  }
}

export const getInventoryItemIdFieldName = (item: InventoryItem): string => {
  if ('placement_id' in item) {
    return 'placement_id'
  } else {
    return 'ad_unit_id'
  }
}

export const getInventoryItemId = (item: InventoryItem): number => {
  const idFieldName = getInventoryItemIdFieldName(item)
  return item[idFieldName]
}

export const getInventoryIds = (inventoryItems: InventoryItem[]): number[] => {
  if (!inventoryItems || inventoryItems.length === 0) {
    return []
  }

  return inventoryItems.map(getInventoryItemId)
}

export const formatRightInventoryOptions = (rightInventory: InventoryItem[]) => {
  const inventoryType = getGamInventoryType(rightInventory)
  return formatOptionsList({
    list: rightInventory || [],
    valueName: inventoryType === inventoryTypes.placements ? 'placement_id' : 'ad_unit_id',
    labelName: 'name'
  } as any)
}

export const getAllOrSpecificInventory = (values: any, right: any) => {
  const allRightInventory = right[AD_INVENTORY] || []
  const selectedInventory = values[RIGHT_INVENTORY_SELECT] || []

  return values[TARGETING_OPTION] === targetingOptions.SPECIFIC_INVENTORY ? selectedInventory : allRightInventory
}
